import React, { Component } from 'react';
import Table from './Table';
import FormContainer from './FormContainer'
import moment from 'moment';
import FileSaver from "file-saver";

const Parse = require('parse');
const cloneDeep = require('lodash.clonedeep');

const IS_UNDEFINED = obj => typeof obj === "undefined";
const IS_EMPTY_STRING = obj => obj === "";
const IS_NULL = obj => obj === null;
const IS_VALID = obj => !IS_UNDEFINED(obj) && !IS_NULL(obj) && !IS_EMPTY_STRING(obj);

class TableContainer extends Component {
	constructor(props, state) {
		super(props, state)
		this.state = {
			data: [],
			count: 0,
			activePage: 1,
			isLoading: false,
			isExporting: false,
			modalShow: false,
			formType: '',
			selectedData: null,
			filter: null,
			sort: {
				column: null,
				condition: 'ascending'
			}
		}

		this.handlePaginate = this.handlePaginate.bind(this);
		this.createQuery = this.createQuery.bind(this);
		this.getTableData = this.getTableData.bind(this);
		this.exportData = this.exportData.bind(this);
		this.handleModalShow = this.handleModalShow.bind(this);
		this.stateSetter = this.stateSetter.bind(this);
		this.accessible = this.accessible.bind(this);

		if (typeof props.refreshTable !== "undefined" && typeof props.refreshTable === "function") {
			props.refreshTable(this.getTableData);
		}
	}

	stateSetter(stateArray) {
		for (var i = 0; i < stateArray.length; i++) {
			this.setState({
				[stateArray[i]['state']]: stateArray[i]['value']
			});
		}
	}

	handleModalShow(mode, selectedData = null) {
		let { schema } = this.props

		console.log({ mode: mode, selectedData: selectedData });

		if (selectedData == null && this.state.selectedData != null) {
			console.log('REVERT dirtyKeys: ', this.state.selectedData.dirtyKeys());
			this.state.selectedData.revert();
			selectedData = null;
		}

		if (mode === 'create') {
			var ClassName = Parse.Object.extend(schema.className);
			var className = new ClassName();
			selectedData = className
		}

		let { modalShow } = this.state
		this.setState({
			modalShow: !modalShow,
			formType: mode,
			selectedData
		})
	}

	handlePaginate(page) {
		console.log(page)
		let { activePage } = this.state;
		if (page === activePage) {
			return;
		}

		this.setState({
			activePage: page
		}, () => {
			this.getTableData()
		})
	}

	componentDidMount() {
		this.getTableData()
	}

	createQuery() {
		let { schema, moduleQuery } = this.props;
		let { activePage, filter, sort } = this.state;
		var limit = schema.limit || 10;
		// console.log({ filter })
		var query = new Parse.Query(schema.className);
		if (typeof moduleQuery !== 'undefined') {
			if (Array.isArray(moduleQuery)) {
				for (var obj of moduleQuery) {
					if (Object.keys(obj).length !== 0) {
						if (
							typeof obj.value !== "undefined"
						) {
							query[obj.method](obj.column, obj.value);
						} else {
							query[obj.method](obj.column);
						}
					}
				}
			} else {
				query = new Parse.Query.fromJSON(schema.className, cloneDeep(moduleQuery));
			}
		}
		query.limit(limit);
		query.skip((activePage - 1) * limit);

		var getPointer = (columns) => {
			var pointerArray = [];
			for (var i in columns) {
				if (columns[i].type.toUpperCase() === 'POINTER') {
					pointerArray.push(columns[i].columnName);
				}
			}
			return pointerArray;
		};

		query.include(getPointer(schema.columns).concat(IS_VALID(schema.include) && Array.isArray(schema.include) ? schema.include : []));

		if (sort.column !== null) {
			query[sort.condition](sort.column.value);
		}

		if (filter !== null) {
			var indexOfColumnName = (columnName) => schema.columns.map((column) => column.columnName).indexOf(columnName);
			for (var i in filter[0]) {
				let index = indexOfColumnName(i);
				switch (schema.columns[index].type.toUpperCase()) {
					case 'STRING':
						if (IS_VALID(filter[0][i])) {
							if (
								!IS_UNDEFINED(schema.columns[index].customFilter) &&
								!IS_UNDEFINED(schema.columns[index].customFilter.onSearch) &&
								typeof schema.columns[index].customFilter.onSearch === "function"
							) {
								query = schema.columns[index].customFilter.onSearch({
                  query,
                  queryMethodName: filter[1][i].value,
                  columnName: i,
                  value: filter[0][i]
                });
							} else {
								query.matches(i, filter[0][i].replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
							}
						}

						break;
					case 'NUMBER':
						if (IS_VALID(filter[0][i])) {
							if (
								!IS_UNDEFINED(schema.columns[index].customFilter) &&
								!IS_UNDEFINED(schema.columns[index].customFilter.onSearch) &&
								typeof schema.columns[index].customFilter.onSearch === "function"
							) {
								query = schema.columns[index].customFilter.onSearch({
									query,
									queryMethodName: filter[1][i].value,
									columnName: i,
									value: filter[0][i]
								});
							} else {
								let numberParsing = schema.columns[index].numberParsing,
									parsedValue = IS_VALID(numberParsing) && numberParsing.toUpperCase() === "FLOAT" ? parseFloat(filter[0][i]) : parseInt(filter[0][i]);

								query[filter[1][i].value](i, parsedValue);
							}
						}
						break;
					case 'DATE':
						if (IS_VALID(filter[0][i])) {
							if (filter[1][i].value === 'equalTo') {
								query.lessThanOrEqualTo(i, moment(filter[0][i]).endOf('day').toDate());
								query.greaterThanOrEqualTo(i, moment(filter[0][i]).startOf('day').toDate());
							} else {
								const dateCondition = (condition) => {
									if (condition === 'greaterThan') {
										return moment(filter[0][i]).endOf('day').toDate();
									} else if (condition === 'lessThan') {
										return moment(filter[0][i]).startOf('day').toDate();
									} else if (condition === 'greaterThanOrEqualTo') {
										return moment(filter[0][i]).startOf('day').toDate();
									} else if (condition === 'lessThanOrEqualTo') {
										return moment(filter[0][i]).endOf('day').toDate();
									}
								};
								query[filter[1][i].value](i, dateCondition(filter[1][i].value));
							}
						}
						break;
					case 'BOOLEAN':
						if (IS_VALID(filter[0][i])) {
							if (
								!IS_UNDEFINED(schema.columns[index].customFilter) && 
								!IS_UNDEFINED(schema.columns[index].customFilter.onSearch) &&
								typeof schema.columns[index].customFilter.onSearch === "function"
							) {
								query = schema.columns[index].customFilter.onSearch({
								  query,
								  queryMethodName: filter[1][i].value,
								  columnName: i,
								  value: filter[0][i]
								});
							  } else {
								query.equalTo(i, filter[0][i].value);
							}
						}
						break;
					case 'POINTER':
						if (IS_VALID(filter[0][i])) {
							var object = Parse.Object.extend(schema.columns[index].targetClass);
							var _object = new object();
							_object.id = filter[0][i].value;
							query.equalTo(i, _object);
						}
						break;
					case "CUSTOM":
						if (IS_VALID(filter[0][i])) {
							if (
								!IS_UNDEFINED(schema.columns[index].customFilter) && 
								!IS_UNDEFINED(schema.columns[index].customFilter.onSearch) &&
								typeof schema.columns[index].customFilter.onSearch === "function"
							) {
								query = schema.columns[index].customFilter.onSearch({
									query,
									queryMethodName: filter[1][i].value,
									columnName: i,
									value: filter[0][i]
								});
							}
						}
						break;
					default:
					// wala
				}
			}
		}

		return query;
	}

	getTableData() {
		let {
      useMasterKey
    } = this.props;

		useMasterKey = IS_VALID(useMasterKey) && typeof useMasterKey === "boolean" ? useMasterKey : false;

		let query = this.createQuery();

		var qCount = cloneDeep(query);
		qCount.limit(-1);
		this.setState({ isLoading: true })

		Promise.all([query.find({ useMasterKey: useMasterKey }), qCount.count({ useMasterKey: useMasterKey })]).then(([data, count]) => {
			// console.log(data,count)
			// console.log('data', data)
			this.setState({ data, count, isLoading: false })
		}).catch((err) => {
			console.log('error detected', err)
		})
	}

	exportData() {
		let {
			schema,
			customExport
		} = this.props;

		let query = this.createQuery();

		this.setState({ isExporting: true });

		if (typeof customExport !== 'undefined' && typeof customExport === 'function') {
			customExport(
				{
					className: query.className,
					queryJson: query.toJSON()
				},
				() => {
					this.setState({ isExporting: false });
				}
			);
		} else {
			Parse.Cloud.run(
				"EXPORT_EXCEL",
				{
					className: query.className,
					queryJSON: query.toJSON(),
					columns: schema.columns
				}
			)
				.then((data) => {
					console.log("data", data);
					let arrayBuffer = new ArrayBuffer(data.data.length);
					let view = new Uint8Array(arrayBuffer);
					for (let i = 0; i < data.data.length; i++) {
						view[i] = data.data[i];
					}

					let blob = new Blob([arrayBuffer], { type: "application/vnd.ms-excel" });
					let dateToday = moment().format("MMM DD, YYYY");
					let fileName = `${IS_VALID(schema.classNameLabel) ? schema.classNameLabel : schema.className} Report - ${dateToday}.xlsx`;

					FileSaver.saveAs(blob, fileName);

					this.setState({ isExporting: false });
				})
				.catch((err) => {
					this.setState({ isExporting: false });
				});
		}
	}

	loadOptions(input, cb, className, columnName) {
		var query = new Parse.Query(className);
		query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
		query.limit(20);
		query.find().then((data) => {
			return data.map((item) => item = {
				label: item.get(columnName),
				value: item.id
			});
		}).then((data) => {
			cb(null, { options: data });
		}).catch((err) => {
			console.log('Load Select Options error: ', err.message);
		});
	}

	accessible(actionType) {
		let { access, schema, customPathname } = this.props;
		if (schema.bypassAccess) {
			return ''
		} else if (typeof access !== 'undefined' && access.length !== 0) {
			var pathname = customPathname;

			if (typeof customPathname !== 'undefined' && customPathname !== '') {
				if (customPathname.charAt(0) !== '/') {
					pathname = '/' + customPathname;
				}

				if (pathname.charAt(pathname.length - 1) === '/') {
					pathname = pathname.slice(0, pathname.length - 1);
				}
			}

			var currentPath = window.location.pathname.replace((pathname || ""), ""),
				index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
				actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
				return 'none';
			}
		} else {
			return 'none';
		}
	}

	render() {
		let {
			count,
			modalShow,
			formType,
			isLoading,
			isExporting,
			activePage,
			selectedData,
			data,
			sort,
			filter
		} = this.state

		let { schema, moduleCreate, moduleUpdate, moduleDelete, saveTrail, useMasterKey } = this.props

		let tableState = {
			data,
			count,
			filter,
			handlePaginate: this.handlePaginate,
			handleModalShow: this.handleModalShow,
			isLoading,
			isExporting,
			activePage,
			stateSetter: this.stateSetter,
			getTableData: this.getTableData,
			exportData: this.exportData,
			loadOptions: this.loadOptions,
			accessible: this.accessible,
			sort,
			query: this.createQuery
		}

		let formState = {
			schema,
			moduleCreate,
			moduleUpdate,
			moduleDelete,
			handleModalShow: this.handleModalShow,
			modalShow,
			formType,
			selectedData,
			getTableData: this.getTableData,
			loadOptions: this.loadOptions,
			saveTrail,
			useMasterKey
		}

		return (
			<div>
				<FormContainer {...formState} />
				<Table {...this.props} {...tableState} />
			</div>
		)
	}
}

export default TableContainer;



// WEBPACK FOOTER //
// ./components/zynappse-crud/TableContainer.js